import React, { useEffect, useState } from 'react';

import {
    useIsConnected,
    useLocalCameraTrack,
    useLocalMicrophoneTrack,
    useJoin,
    usePublish,
    useRemoteUsers,
    // useRemoteAudioTracks,
    RemoteUser,
    LocalUser,
    useRTCClient,
    useClientEvent,
    // useCurrentUID,
} from 'agora-rtc-react';

import { Container, Row, Col, Button, Spinner } from 'react-bootstrap';
import { FiMic, FiVideo, FiX } from 'react-icons/fi'; // React Icons for microphone, video, and close
import { FaPaperclip, FaSmile, FaPaperPlane } from 'react-icons/fa';

const AgoraConfig = {
    // appId: "0feea1b1632c49cebb1b8aa53b7fdc00", //web
    appId: process.env.REACT_APP_AGORA_APP_ID, // mobile
    channel: "abcd",
    token: null,
}

function FreeVideCall() {
    const client = useRTCClient();
    const isConnected = useIsConnected();
    // const currentUid = useCurrentUID();


    const [CallOptions, setCallOptions] = useState({
        inCall: false,
        micOn: false,
        cameraOn: false,
        isLocalBig: false,
    });


    const { isLoading } = useJoin(
        {
            appid: AgoraConfig.appId,
            channel: AgoraConfig.channel,
            token: AgoraConfig.token,
        },
        CallOptions.inCall,
    );


    const { localMicrophoneTrack } = useLocalMicrophoneTrack(CallOptions.micOn);
    const { localCameraTrack } = useLocalCameraTrack(CallOptions.cameraOn);


    usePublish([localMicrophoneTrack, localCameraTrack]);


    // remote users
    const remoteUsers = useRemoteUsers();


    useEffect(() => {
        console.log('remoteUsers: ', remoteUsers);
    }, [remoteUsers]);




    /////////////// agora events  //////////////////////////
    useClientEvent(client, 'user-joined', user => {
        console.log('user-joined', user);
    });

    useClientEvent(client, 'user-left', () => {
        console.log('User left');
        handleLeaveCall();
    });

    useClientEvent(client, 'user-published', async () => {
        console.log('user-published');
    });

    useClientEvent(client, 'user-unpublished', () => {
        console.log('User unpublished');
    });



    /////////////////  custom functions  ////////////////
    const handleJoinCall = async () => {
        if (!CallOptions.inCall) {
            try {

                setCallOptions((prev) => ({
                    ...prev,
                    inCall: true,
                    micOn: true,
                    cameraOn: true,
                    isLocalBig: false,
                }));

                // Start and publish local tracks
                // localMicrophoneTrack?.start();
                // localCameraTrack?.start();

                // // Join the Agora client
                // await client.join(AgoraConfig.appId, AgoraConfig.channel, AgoraConfig.token);

            } catch (error) {
                console.error('Error joining call:', error);
            }
        }
    };

    const handleLeaveCall = async () => {
        if (CallOptions.inCall) {
            try {

                // Leave the Agora client
                await client.leave();

                // Stop and close local tracks
                localMicrophoneTrack?.stop();
                localMicrophoneTrack?.close();
                localCameraTrack?.stop();
                localCameraTrack?.close();

                // Reset client listeners
                client.removeAllListeners();

                setCallOptions((prev) => ({
                    ...prev,
                    inCall: false,
                    micOn: false,
                    cameraOn: false,
                    isLocalBig: false,
                }));

                window.location.replace('/free-video-call');
            } catch (error) {
                console.error('Error leaving call:', error);
            }
        }
    };

    const handleVideoSwap = () => {
        setCallOptions((prev) => ({
            ...prev,
            isLocalBig: !prev.isLocalBig,
        }));
    };

    const toggleMic = () => {
        if (CallOptions.micOn) {
            localMicrophoneTrack?.setEnabled(false);
        } else {
            localMicrophoneTrack?.setEnabled(true);
        }

        setCallOptions((prev) => ({
            ...prev,
            micOn: !prev.micOn,
        }));
    };

    const toggleCamera = () => {
        if (CallOptions.cameraOn) {
            localCameraTrack?.setEnabled(false);
        } else {
            localCameraTrack?.setEnabled(true);
        }

        setCallOptions((prev) => ({
            ...prev,
            cameraOn: !prev.cameraOn,
        }));
    };


    // All Video Action Buttons Object
    const IconObjs = [
        { id: 1, icon: <FiX size={24} />, variant: (CallOptions.inCall ? 'danger' : 'light'), onClick: handleLeaveCall },
        { id: 2, icon: <FiVideo size={24} />, variant: (CallOptions.cameraOn ? 'danger' : 'light'), onClick: toggleCamera },
        { id: 3, icon: <FiMic size={24} />, variant: (CallOptions.micOn ? 'danger' : 'light'), onClick: toggleMic },
    ];


    return (<>

        <Container
            fluid
            className="m-0 p-0"
            style={{ height: '70vh', overflow: 'hidden' }}
        >
            {/* Join Call Button */}
            {!CallOptions.inCall && (
                <Col lg={12} className="d-flex flex-column justify-content-center align-items-center h-100">
                    <Button onClick={handleJoinCall} className="btn btn-primary">Join Call</Button>
                </Col>
            )}

            {/* Video Section */}
            {(!isLoading) && CallOptions.inCall && (
                <Row className="m-0 gy-4" style={{ height: '100%' }}>
                    <Col lg={12} className="d-flex flex-column" style={{ height: '100%' }}>
                        <div
                            className="bg-dark position-relative"
                            style={{ height: '100%', overflow: 'hidden' }}
                        >
                            {/* Larger Screen */}
                            {CallOptions.inCall && CallOptions.isLocalBig && isConnected ? (
                                <LocalUser
                                    audioTrack={localMicrophoneTrack}
                                    videoTrack={localCameraTrack}
                                    cameraOn={CallOptions.cameraOn}
                                    micOn={CallOptions.micOn}
                                    playAudio={false}
                                    cover="https://www.agora.io/en/wp-content/uploads/2022/10/3d-spatial-audio-icon.svg"
                                />
                            ) : (
                                remoteUsers.map(user => (
                                    <RemoteUser
                                        key={user.uid}
                                        user={user}
                                        cover="https://www.agora.io/en/wp-content/uploads/2022/10/3d-spatial-audio-icon.svg"
                                        videoPlayerConfig={{ fit: 'cover', mirror: true }}
                                    />
                                ))
                            )}

                            {/* Smaller Screen */}
                            <div
                                className="bg-light position-absolute"
                                style={{
                                    width: '180px',
                                    height: '100px',
                                    top: '20px',
                                    right: '20px',
                                    borderRadius: '12px',
                                    cursor: 'pointer',
                                }}
                                onClick={handleVideoSwap}
                            >
                                {!CallOptions.isLocalBig && isConnected ? (
                                    <LocalUser
                                        audioTrack={localMicrophoneTrack}
                                        videoTrack={localCameraTrack}
                                        cameraOn={CallOptions.cameraOn}
                                        micOn={CallOptions.micOn}
                                        playAudio={false}
                                        cover="https://www.agora.io/en/wp-content/uploads/2022/10/3d-spatial-audio-icon.svg"
                                    />
                                ) : (
                                    remoteUsers.map(user => (
                                        <RemoteUser
                                            key={user.uid}
                                            user={user}
                                            cover="https://www.agora.io/en/wp-content/uploads/2022/10/3d-spatial-audio-icon.svg"
                                            videoPlayerConfig={{ fit: 'cover', mirror: true }}
                                        />
                                    ))
                                )}
                            </div>

                            {/* Action Buttons */}
                            <div className="position-absolute bottom-0 start-50 translate-middle-x mb-5" style={{ zIndex: 9999999999 }}>
                                <div className="d-flex gap-3">
                                    {IconObjs.map(iconObj => (
                                        <Button
                                            key={iconObj.id}
                                            onClick={iconObj.onClick}
                                            variant={iconObj.variant}
                                            className="rounded-circle p-3"
                                        >
                                            {iconObj.icon}
                                        </Button>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            )}
        </Container>


    </>)
}

export default FreeVideCall;